import { render, staticRenderFns } from "./menu-sales-pay.vue?vue&type=template&id=77cc95ec&"
import script from "./menu-sales-pay.vue?vue&type=script&lang=js&"
export * from "./menu-sales-pay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports